// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3TDSA","savePackageButton":"ClientWallet_savePackageButton__3BKxj"};